// DS: i4.35
import React from 'react';
import IconWrap from '../../IconWrap';
const CommissionBrush = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "32",
        height: "32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m20.226 13.372-1.944-1.81c-1.906-3.396 2.293-7.911 8.426-6.153.326.093.393.517.12.718-.58.427-1.266 1.283-1.35 2.962-.163 3.376-2.511 5.912-5.252 4.283ZM18.215 14.29c1.036 1.042 1.08 3.304.1 4.28-3.4 2.678-11.203 8.811-11.197 8.808l-.006.003c-.404.193-1.043 0-1.54-.498-.474-.473-.672-1.075-.524-1.48 0 0 6.654-8.426 8.89-11.234.98-.975 3.24-.92 4.277.122Z"
    })));
CommissionBrush.displayName = 'CommissionBrush';
export default CommissionBrush;
